import api from './api';

export interface Debt {
  id: number;
  customer_id: number | null;
  stock_out_voucher_id: number | null;
  debt_amount: number;
  paid_amount: number;
  status: 'unpaid' | 'partial' | 'paid';
  created_at: string;
  updated_at: string;
  // Thông tin khách hàng từ API response
  customer_name?: string;
  customer_code?: string;
  customer_phone?: string;
  customer_address?: string;
}

export interface DebtPayment {
  id: number;
  customer_debt_id: number;
  payment_date: string;
  amount: number;
  note?: string;
  created_at: string;
}

export const debtService = {
  // Lấy danh sách công nợ
  getDebts: async (customer_id?: string) => {
    const res = await api.get('/api/stock/debts', { params: customer_id ? { customer_id } : {} });
    return res.data.data as Debt[];
  },
  // Lấy chi tiết công nợ + lịch sử thanh toán
  getDebtDetail: async (id: number) => {
    const res = await api.get(`/api/stock/debts/${id}`);
    return res.data.data as { debt: Debt; payments: DebtPayment[] };
  },
  // Tạo thanh toán cho công nợ
  createPayment: async (debtId: number, amount: number, note?: string) => {
    await api.post(`/api/stock/debts/${debtId}/payments`, { amount, note });
  },
  // Lấy lịch sử thanh toán
  getPayments: async (debtId: number) => {
    const res = await api.get(`/api/stock/debts/${debtId}/payments`);
    return res.data.data as DebtPayment[];
  },
  // Lấy thống kê công nợ theo khách hàng (mới)
  getDebtSummary: async () => {
    const res = await api.get('/api/stock/debts/summary');
    return res.data as { data: any[]; totals: any };
  },
}; 